import { Image } from 'react-bootstrap';
import { fetchPosts } from '../../utils/blogUtils';
import { PostSlider } from '../../components/blog';
import { useState, useEffect } from 'react';

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts().then((data) => {
      setPosts(data);
      setLoading(false);
    });
  }, []);

  if (loading) return <div>Cargando blogs...</div>;


  return (
    <>
      <Image src='/images/blog/blog_banner_1.png' className='w-100' id='blogBanner'></Image>
      <section className='d-flex align-items-center w-100 bg-green-light-cu-2 p-lg-5 py-lg-5 py-5 flex-column gap-5' id="blog">
        <PostSlider posts={posts} description />
        {/* <div className='d-flex justify-content-center'>
          <Button style={{ backgroundColor: "#8FB93E", borderColor: "#8FB93E" }} className={`carousel-button  rounded-1 ` + (disabled ? 'd-none' : '')} onClick={handleShowAll} >Ver Todos</Button>
        </div> */}
      </section>
    </>
  );
}

export default BlogPage;